import { render, staticRenderFns } from "./product_classify.vue?vue&type=template&id=5d53edeb&scoped=true"
import script from "./product_classify.vue?vue&type=script&lang=js"
export * from "./product_classify.vue?vue&type=script&lang=js"
import style0 from "./product_classify.vue?vue&type=style&index=0&id=5d53edeb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53edeb",
  null
  
)

export default component.exports